import { Icon as e } from "../icon/index.js";
import { cn as t } from "../cn.js";
import { menuCheckboxItemStyles as n, menuContentStyles as r, menuContextTriggerStyles as i, menuGroupStyles as a, menuItemIndicatorStyles as o, menuItemStyles as s, menuItemTextStyles as c, menuLabelStyles as l, menuRadioItemStyles as u, menuSeparatorStyles as d, menuTriggerStyles as f } from "./style.js";
import * as p from "react";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
import { Portal as _ } from "@ark-ui/react/portal";
import { Menu as v } from "@ark-ui/react/menu";
// src/design/menu/index.tsx
var y = p.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ h(v.Root, {
	...t,
	children: e
}));
y.displayName = "Menu.Root";
var b = p.forwardRef(({ children: n, className: r, variant: i, size: a, asChild: o, ...s }, c) => /* @__PURE__ */ h(v.Trigger, {
	ref: c,
	asChild: o,
	className: o ? void 0 : t(f({
		variant: i,
		size: a
	}), r),
	...s,
	children: o ? n : /* @__PURE__ */ g(m, { children: [n, i !== "icon" && /* @__PURE__ */ h(v.Indicator, {
		className: "transition-transform duration-normal data-[state=open]:rotate-180",
		children: /* @__PURE__ */ h(e, {
			name: "ChevronDown",
			size: "xs"
		})
	})] })
}));
b.displayName = "Menu.Trigger";
var x = p.forwardRef(({ children: e, className: n, ...r }, a) => /* @__PURE__ */ h(v.ContextTrigger, {
	ref: a,
	className: t(i(), n),
	...r,
	children: e
}));
x.displayName = "Menu.ContextTrigger";
var S = p.forwardRef(({ children: e, className: n, width: i = "auto", ...a }, o) => /* @__PURE__ */ h(_, { children: /* @__PURE__ */ h(v.Positioner, { children: /* @__PURE__ */ h(v.Content, {
	ref: o,
	className: t(r({ width: i }), n),
	...a,
	children: e
}) }) }));
S.displayName = "Menu.Content";
var C = p.forwardRef(({ children: n, className: r, icon: i, shortcut: a, variant: o = "default", disabled: c, value: l, closeOnSelect: u, asChild: d, onClick: f, ...m }, _) => {
	let y = p.useCallback(() => {
		d || f?.();
	}, [f, d]);
	return d ? /* @__PURE__ */ h(v.Item, {
		ref: _,
		asChild: !0,
		disabled: c,
		closeOnSelect: u,
		value: l,
		...m,
		children: n
	}) : /* @__PURE__ */ g(v.Item, {
		ref: _,
		disabled: c,
		closeOnSelect: u,
		value: l,
		className: t(s({ variant: o }), r),
		onClick: y,
		...m,
		children: [
			i && /* @__PURE__ */ h(e, {
				name: i,
				size: "sm",
				className: o === "danger" ? "text-destructive" : "text-muted-foreground"
			}),
			/* @__PURE__ */ h(v.ItemText, {
				className: "flex-1",
				children: n
			}),
			a && /* @__PURE__ */ h("span", {
				className: "ml-auto text-xs text-muted-foreground font-mono",
				children: a
			})
		]
	});
});
C.displayName = "Menu.Item";
var w = p.forwardRef(({ className: e, ...n }, r) => /* @__PURE__ */ h(v.Separator, {
	ref: r,
	className: t(d(), e),
	...n
}));
w.displayName = "Menu.Separator";
var T = p.createContext(!1), E = p.forwardRef(({ children: e, className: n, casing: r = "upper", ...i }, a) => {
	let o = p.useContext(T), s = t(l({ casing: r }), n);
	return o ? /* @__PURE__ */ h(v.ItemGroupLabel, {
		ref: a,
		className: s,
		...i,
		children: e
	}) : /* @__PURE__ */ h("div", {
		ref: a,
		role: "presentation",
		className: s,
		...i,
		children: e
	});
});
E.displayName = "Menu.Label";
var D = p.forwardRef(({ children: e, className: n, ...r }, i) => /* @__PURE__ */ h(v.ItemGroup, {
	ref: i,
	className: t(a(), n),
	...r,
	children: /* @__PURE__ */ h(T.Provider, {
		value: !0,
		children: e
	})
}));
D.displayName = "Menu.Group";
var O = p.forwardRef(({ children: n, className: r, icon: i, asChild: a, ...o }, c) => /* @__PURE__ */ h(v.TriggerItem, {
	ref: c,
	asChild: a,
	className: a ? void 0 : t(s({ variant: "default" }), "justify-between", r),
	...o,
	children: a ? n : /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ g("div", {
		className: "flex items-center gap-3 flex-1",
		children: [i && /* @__PURE__ */ h(e, {
			name: i,
			size: "sm",
			className: "text-muted-foreground"
		}), n]
	}), /* @__PURE__ */ h(e, {
		name: "ChevronRight",
		size: "xs",
		className: "text-muted-foreground"
	})] })
}));
O.displayName = "Menu.TriggerItem";
var k = p.forwardRef(({ children: e, className: n, ...r }, i) => /* @__PURE__ */ h(v.ItemText, {
	ref: i,
	className: t(c(), n),
	...r,
	children: e
}));
k.displayName = "Menu.ItemText";
var A = p.forwardRef(({ children: e, className: r, ...i }, a) => /* @__PURE__ */ h(v.CheckboxItem, {
	ref: a,
	className: t(n(), r),
	...i,
	children: e
}));
A.displayName = "Menu.CheckboxItem";
var j = p.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ h(v.RadioItemGroup, {
	ref: r,
	className: t,
	...n,
	children: /* @__PURE__ */ h(T.Provider, {
		value: !0,
		children: e
	})
}));
j.displayName = "Menu.RadioItemGroup";
var M = p.forwardRef(({ children: e, className: n, ...r }, i) => /* @__PURE__ */ h(v.RadioItem, {
	ref: i,
	className: t(u(), n),
	...r,
	children: e
}));
M.displayName = "Menu.RadioItem";
var N = p.forwardRef(({ children: e, className: n, ...r }, i) => /* @__PURE__ */ h(v.ItemIndicator, {
	ref: i,
	className: t(o(), n),
	...r,
	children: e
}));
N.displayName = "Menu.ItemIndicator";
var P = p.forwardRef(({ trigger: e, items: t = [], groups: n = [], onSelect: r, className: i, contentWidth: a = "auto", positioning: o, ...s }, c) => {
	let l = p.useCallback((e) => {
		let i = [...t, ...n.flatMap((e) => e.items)].find((t) => t.value === e.value);
		i?.onClick && i.onClick(), r && r(e.value);
	}, [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ g(y, {
		onSelect: l,
		positioning: o,
		...s,
		children: [p.isValidElement(e) && (e.type === b || e.type === x) ? e : /* @__PURE__ */ h(v.Trigger, {
			asChild: !0,
			children: e
		}), /* @__PURE__ */ g(S, {
			width: a,
			className: i,
			children: [t.length > 0 && t.map((e) => /* @__PURE__ */ h(C, {
				value: e.value,
				icon: e.icon,
				shortcut: e.shortcut,
				disabled: e.disabled,
				children: e.label
			}, e.value)), n.map((e, n) => /* @__PURE__ */ g(p.Fragment, { children: [(t.length > 0 || n > 0) && /* @__PURE__ */ h(w, {}), /* @__PURE__ */ g(D, { children: [e.label && /* @__PURE__ */ h(E, { children: e.label }), e.items.map((e) => /* @__PURE__ */ h(C, {
				value: e.value,
				icon: e.icon,
				shortcut: e.shortcut,
				disabled: e.disabled,
				children: e.label
			}, e.value))] })] }, n))]
		})]
	});
});
P.displayName = "Menu.Default";
var F = {
	Root: y,
	Trigger: b,
	ContextTrigger: x,
	Content: S,
	Item: C,
	Separator: w,
	Label: E,
	Group: D,
	TriggerItem: O,
	Default: P,
	ItemText: k,
	CheckboxItem: A,
	RadioItemGroup: j,
	RadioItem: M,
	ItemIndicator: N,
	Arrow: v.Arrow,
	ArrowTip: v.ArrowTip,
	Positioner: v.Positioner
};
export { F as Menu };

//# sourceMappingURL=index.js.map